import { useEffect, useState } from "react";

import { useLazyGetLookupAttributeNameQuery } from "../../services/attributeDataApi";
import { useParams } from "react-router-dom";

export const ReadOnlyLookupAttribute = ({
    attributeId,
    value,
}: {
    attributeId: string,
    value?: string,
    className?: string,
}) => {
    const { siteId } = useParams()
    const [getLookupName, { data, isSuccess, isError }] = useLazyGetLookupAttributeNameQuery()
    const [lookupValue, setLookupValue] = useState<string>();

    useEffect(() => {
        if (!value || !siteId) {
            return setLookupValue('')
        }
        
        getLookupName({ siteId, attributeId, valueId: value })
        // eslint-disable-next-line
    }, [siteId, value])

    useEffect(() => {
        if (isSuccess && data) {
            // const entity = data.find(p => `${p.id}` === value)
            setLookupValue(data?.name)
        }
        // eslint-disable-next-line
    }, [isSuccess, data])

    if (isError) {
        <span className='alert-info' style={{ display: 'block' }}>
            Failed to load lookup data
        </span>
    }

    return (<>{lookupValue}</>)
}
